import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
//api
import { deletePost } from 'api/blog';
import { getPosts } from 'api/pathForHook/blog';
//utils
import useHandleSearch from 'utils/customHooks/useHandleSearch';
//components
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import Button from 'components/backoffice/buttonCustom';
import DeleteModalCustom from 'components/backoffice/modals/DeleteModalCustom';
import Title from 'components/backoffice/texts/title';
import { usePermissions } from 'components/backoffice/PermissionsContext';
import FiltersTablePosts from './FiltersTablePosts';
import StatusBudget from 'components/budget/StatusBudget';

const Posts = () => {
  const userPermissions = usePermissions();
  const { t } = useTranslation(['backoffice']);
  const navigate = useNavigate();
  const [listPosts, setListPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [idItem, setIdItem] = useState();
  const [form, setForm] = useState({});
  const [responseInfo, setResponseInfo] = useState({});
  const { setTitle } = useOutletContext()

  const colsPosts = [t('titulo'), t('category'), t('autor'), t('fechapublicado'), t('state'), t('actions')];

  const { fetchData, stateData, loading } = useHandleSearch();

  const getListPosts = async () => {
    try {
      let payload = {
        page,
        page_size: 10,
        title: form.title || '',
        author: form.author || '',
        body: form.body || '',
        fields: 'id,title,author,publish_date,status,category,status_display',
      }
      await fetchData(getPosts(), payload);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTitle(t('posts'))
    return () => {
      setTitle('');
    };
  }, [setTitle])

  useEffect(() => {
    const { results, errors, totalPages, noResults } = stateData;
    if (results !== null) {
      setListPosts(results);
      setResponseInfo({ errors, totalPages, noResults })
    } else {
      setListPosts(null);
      setResponseInfo({ errors })
    }
  }, [stateData])

  useEffect(() => {
    getListPosts();
  }, [page, form]);

  const handleClear = () => {
    setForm({
      title: '',
      author: '',
      body: '',
    });
    setPage(1);
    setResponseInfo(prevResponseInfo => ({ ...prevResponseInfo, noResults: false }));
    getListPosts();
  };

  const handleCreate = () => {
    navigate('/intranet/posts/create');
  };

  const handleEdit = (id) => {
    navigate(`/intranet/posts/edit/${id}`);
  };

  const handleDelete = (item, id, setOpenModal) => {
    if (item.id === id) {
      setOpenModal(true);
      setIdItem(id);
    }
  };

  const onDelete = useCallback(async () => {
    try {
      const { status } = await deletePost(idItem);
      if (status === 204) {
        toast.success(t('eliminadocorrectamente'));
        setForm({
          title: '',
          author: '',
          body: '',
        });
      } else {
        toast(`${t('error')} ${status}: ${t('mensajeerror')}`);
      }
    } catch (error) {
      console.log(error);
    }
  }, [openModalDelete]);

  const serializerStatusSchedule = (status) => {
    if (status === 'Published') {
      return 'success';
    } else if (status === 'Draft') {
      return 'warning';
    } else if (status === 'Hidden') {
      return 'danger';
    }
    return 'info';
  };

  return (
    <div className="d-lg-grid">
      <Title text={t('posts')} />
      <Row className="d-flex w-md-100 mt-3">
        <Col xl={9} lg={12} md={12} xs={12} className="d-flex text-start">
          <FiltersTablePosts
            form={form}
            handleClear={handleClear}
            setFormFilter={setForm}
            t={t}
            page={page}
            setPage={setPage}
          />
        </Col>
        <Col xl={3} lg={12} md={12} xs={12} className="d-flex text-end align-bottom p-xl-0 justify-content-end pt-5 pt-xl-0">
          {userPermissions.includes('category.__view') && (
            <Button
              extraClass="py-1 mx-3"
              color={'primary'}
              onClick={() => navigate('/intranet/blog-categories')}>
              {t('categories')}
            </Button>
          )}
          {userPermissions.includes('post.__add') && (
            <Button color={'primary'} onClick={handleCreate}>
              {t('crear')}
            </Button>
          )}
        </Col>
      </Row>
      <div className="table-responsive">
        <CustomTable
          cols={colsPosts}
          noResults={responseInfo?.noResults}
          isLoading={loading}
          page={page}
          changePage={setPage}
          totalPages={responseInfo?.totalPages}
        >
          {listPosts &&
            listPosts?.map((listPost, index) => {
              return (
                <tr key={listPost.id}>
                  <td>{listPost.title}</td>
                  <td>{listPost?.category?.name}</td>
                  <td>{listPost?.author}</td>
                  <td>{listPost?.publish_date}</td>
                  <td>
                    <div className="d-flex justify-content-center">
                      <StatusBudget
                        text={listPost?.status_display}
                        status={serializerStatusSchedule(listPost?.status_display)}
                      />
                    </div>
                  </td>
                  <td className="item-dropdown text-end">
                    <DropdownIcons
                      idItem={index}
                      idList={listPost.id}
                      handleEdit={userPermissions.includes('post.__modify') && (() => handleEdit(listPost.id))}
                      setOpenModalDelete={setOpenModalDelete}
                      handleDelete={
                        userPermissions.includes('post.__delete') &&
                        (() => handleDelete(listPost, listPost.id, setOpenModalDelete))
                      }
                    />
                  </td>
                </tr>
              );
            })}
        </CustomTable>
      </div>
      {openModalDelete && (
        <DeleteModalCustom
          openModal={openModalDelete}
          setOpenModal={setOpenModalDelete}
          handleDelete={onDelete}
          deleteTitle={t('deletepost')}
          beforeTitle={t('posts')}
        />
      )}
    </div>
  );
};

export default Posts;